import { c as _c } from "react/compiler-runtime";
interface ArrowIconProps {
  className?: string;
  size?: number;
  onClick?: (e: React.MouseEvent<SVGElement>) => void;
}
export default function ArrowIcon(t0) {
  const $ = _c(6);
  const {
    className: t1,
    size: t2,
    onClick
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const size = t2 === undefined ? 20 : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g clipPath="url(#clip0_83_336)"><path d="M10 4.38278L10.5446 4.91926L20 14.6304L18.9107 15.75L10 6.59091L1.08926 15.75L0 14.6304L9.45537 4.91148L10 4.375V4.38278Z" fill="currentColor" /></g>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <defs><clipPath id="clip0_83_336"><rect width="20" height="11.375" fill="white" transform="matrix(1 0 0 -1 0 15.75)" /></clipPath></defs>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== className || $[3] !== onClick || $[4] !== size) {
    t5 = <svg width={size} height={size} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>{t3}{t4}</svg>;
    $[2] = className;
    $[3] = onClick;
    $[4] = size;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}